var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.ShapeFileLayerGroup = new Class({
    Extends: OCS.Viewer.Classes.LayerGroup,
    class_name: "ShapeFileLayerGroup",
    style_manager_class: OCS.Viewer.Functions.define_ol_style_manager([new Class(OCS.Viewer.Interfaces.OlShapeStyle)]),

    get_layer_name: function () {
        var variable = this.get_variables()[0];
        return OCS.Viewer.Functions.get_utilities().ucwords(variable.units + " " + variable.parm).replace('_', ' ');
    },
    get_layer_short_name: function () {
        var variable = this.get_variables()[0];
        return OCS.Viewer.Functions.get_utilities().ucwords(variable.units + " " + variable.parm).replace('_', ' ');
    },
});